import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="py-12 text-center">
      <h1 className="text-2xl font-bold">{t("notFound.heading")}</h1>
      <p className="mt-2 text-slate-600 dark:text-slate-400">{t("notFound.body")}</p>
      <Link to="/" className="text-brand-600 mt-6 inline-block underline">
        {t("notFound.backHome")}
      </Link>
    </div>
  );
}
